import { KitTypeAndDescription, VisitHbsConfig, VisitHbsKitConfig } from '@csp/csp-common-hbs-model';
import { Maybe } from '@csp/csp-common-model';
import { KitTypeAndDescriptionsMapper } from './KitTypeAndDescriptionsMapper';

const from = (
  hbsConfig: VisitHbsConfig,
  typeAndDescriptions: KitTypeAndDescription[],
  supportedKitsFromCms: Maybe<string[]> = [],
): VisitHbsKitConfig => ({
  enabled: hbsConfig.enabled,
  kitTypes: hbsConfig.kitTypes,
  supportedKits: KitTypeAndDescriptionsMapper.from(hbsConfig.kitTypes, typeAndDescriptions),
  supportedKitsFromCms,
});

export const VisitHbsKitConfigMapper = {
  from,
};
